/**
 * Wrap a state/navigation update in the native View Transitions API so the
 * browser cross-fades (or slides, when a direction is given) between the old
 * and new DOM. Falls back to a plain call on browsers without support
 * (Firefox stable, older Safari).
 *
 * When `direction` is provided we set `data-swipe-dir` on <html> for the
 * lifetime of the transition; the matching CSS in index.css turns the
 * default cross-fade into a horizontal slide.
 */
export function withViewTransition(
  update: () => void,
  direction?: 'forward' | 'back',
) {
  const doc = document as Document & {
    startViewTransition?: (cb: () => void) => { finished: Promise<void> }
  }

  if (typeof doc.startViewTransition !== 'function') {
    update()
    return
  }

  if (direction) {
    doc.documentElement.dataset.swipeDir = direction
  }

  const transition = doc.startViewTransition(update)

  if (direction) {
    transition.finished.finally(() => {
      // Only clear if no other transition has overwritten it in the meantime
      if (doc.documentElement.dataset.swipeDir === direction) {
        delete doc.documentElement.dataset.swipeDir
      }
    })
  }
}
